import React from 'react';
import AdminRowIcon from '../../components/admin/AdminRowIcon';
import { leafOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  IonSpinner,
  IonText,
} from '@ionic/react';
import { useAdminLots } from '../../../application/use-cases/admin/useAdminLots';
import { formatDate, formatGdd } from '../../../domain/Lot';
import AdminListFooter from '../../components/admin/AdminListFooter';
import './Admin.css';

// Lotes de todos los usuarios, para ayudar a un cliente: cada uno se abre y
// se edita como si fuera el dueño.
const AdminLots: React.FC = () => {
  const history = useHistory();
  const { items: lots, total, query, setQuery, loading, loadingMore, loadMore, error } = useAdminLots();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/admin" />
          </IonButtons>
          <IonTitle>Lotes ({total.toLocaleString('es-AR')})</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSearchbar value={query} placeholder="Buscar por lote, cultivo o dueño" onIonInput={(e) => setQuery(e.detail.value ?? '')} />
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {loading && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}
        {error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}
        {!loading && !error && lots.length === 0 && !query && (
          <IonText color="medium">
            <p className="ion-padding">Ningún usuario cargó lotes todavía.</p>
          </IonText>
        )}

        <IonList className="admin-list">
          {lots.map((lot) => {
            const ph = lot.status?.phenology;
            return (
              <IonItem key={lot.id} lines="full" button detail onClick={() => history.push(`/app/admin/lots/${lot.id}`)}>
                <AdminRowIcon icon={leafOutline} tone={ph ? 'green' : 'brown'} />
                <IonLabel>
                  <h2>{lot.name}</h2>
                  <p>
                    {lot.crop} · {lot.ownerName} ({lot.ownerEmail})
                  </p>
                  <p className="admin-list-row-meta">
                    {lot.cycleStart ? `Siembra ${formatDate(lot.cycleStart)}` : 'Sin fecha de siembra'} ·{' '}
                    {lot.stations.length} estaci{lot.stations.length === 1 ? 'ón' : 'ones'}
                    {ph && lot.stations.length > 0 ? ` · ${lot.stages[ph.stageIndex].name} (${formatGdd(ph.accumulated)} °Cd)` : ''}
                  </p>
                </IonLabel>
              </IonItem>
            );
          })}
        </IonList>
        {!loading && <AdminListFooter shown={lots.length} total={total} loadingMore={loadingMore} onMore={loadMore} />}
      </IonContent>
    </IonPage>
  );
};

export default AdminLots;
